import React from "react";

function StackRevenueIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 15.5C22 18.2615 19.7615 20.5 17 20.5C16.105 20.5 15.264 20.265 14.537 19.8525C13.7671 19.4161 13.1266 18.7833 12.6809 18.0187C12.2353 17.2541 12.0003 16.385 12 15.5C12 14.216 12.484 13.045 13.279 12.16C13.7475 11.6371 14.3212 11.219 14.9624 10.9329C15.6035 10.6469 16.2979 10.4993 17 10.5C19.7615 10.5 22 12.7385 22 15.5Z"
        stroke="#9810FB"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 6V10.5C16.2979 10.4993 15.6035 10.6469 14.9624 10.9329C14.3212 11.219 13.7475 11.6371 13.279 12.16C12.4538 13.0766 11.998 14.2667 12 15.5C12.0007 15.79 12.0247 16.073 12.072 16.349C12.198 17.079 12.4845 17.7719 12.9107 18.3778C13.337 18.9837 13.8925 19.4873 14.537 19.8525C13.206 20.255 11.439 20.5 9.5 20.5C5.358 20.5 2 19.3805 2 18V6"
        stroke="#9810FB"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 14C2 15.3805 5.358 16.5 9.5 16.5C10.4035 16.5 11.27 16.447 12.072 16.349M2 10C2 11.3805 5.358 12.5 9.5 12.5C10.878 12.5 12.1695 12.376 13.279 12.16M19.25 14.5L16.5 17.25L15 15.75M17 6C17 7.3805 13.642 8.5 9.5 8.5C5.358 8.5 2 7.3805 2 6C2 4.6195 5.358 3.5 9.5 3.5C13.642 3.5 17 4.6195 17 6Z"
        stroke="#9810FB"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default StackRevenueIcon;
